function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Attachment from "./Attachment";
const DownloadBlockedAttachment = props => {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  const renderer = () => /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      padding: "10px 10px 10px 8px",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      fontFamily: "Segoe UI, Arial, sans-serif"
    }
  }, " ", props.textCard.attachment.name, " "), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "auto",
      paddingRight: "10px"
    }
  }, props.extraContent && props.extraContent));
  return /*#__PURE__*/React.createElement(Attachment, _extends({}, props, {
    imageCard: undefined,
    renderer: renderer
  }));
};
export default DownloadBlockedAttachment;